export type AdditionalCptCodeQuantities = Record<string, number | string>;

export function isValidAdditionalCptQuantity(value: number | string): boolean {
  return (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= 1 &&
    value <= 99
  );
}

export function normalizeAdditionalCptQuantities(
  selectedIds: string[],
  quantities: AdditionalCptCodeQuantities
): Record<string, number> {
  return Object.fromEntries(
    selectedIds.map((id) => [
      id,
      isValidAdditionalCptQuantity(quantities[id]) ? quantities[id] : 1,
    ])
  ) as Record<string, number>;
}

export function reconcileAdditionalCptQuantities(
  previousSelectedIds: string[],
  nextSelectedIds: string[],
  quantities: AdditionalCptCodeQuantities
): AdditionalCptCodeQuantities {
  const previous = new Set(previousSelectedIds);
  return Object.fromEntries(
    nextSelectedIds.map((id) => [
      id,
      previous.has(id) ? quantities[id] ?? 1 : 1,
    ])
  );
}
